import { type CSSProperties, type ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export function ButtonCol(props: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={twMerge('flex flex-col gap-3', props.className ?? '')} style={props.style}>
      {props.children}
    </div>
  );
}
